import { type ComponentProps } from "react";

export const Snow = (props: ComponentProps<"svg">) => (
  <svg
    width="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9945 16.0012L8.881 18.992L4.82772 17.1314L3.99567 18.9618L6.7618 20.2315L5.24028 21.1214L6.23056 22.859L7.75183 21.9693L7.45427 25.0305L9.43499 25.2156L9.87104 20.7298L14.9869 17.7376V23.7528L11.367 26.3801L12.5418 27.9988L14.9869 26.2241V28H16.9869V26.224L19.4322 27.9988L20.607 26.3801L16.9869 23.7527V17.7514L22.1142 20.7503L22.5503 25.2367L24.531 25.0515L24.2334 21.9898L25.755 22.8798L26.7453 21.1422L25.2239 20.2523L27.9896 18.9828L27.1576 17.1525L23.1047 19.0128L17.9556 16.0012L23.0888 12.9988L27.1685 14.8715L28.0005 13.0412L25.208 11.7593L26.7473 10.859L25.757 9.12142L24.2472 10.0045L24.5419 6.97248L22.5612 6.78729L22.128 11.244L16.9869 14.251V8.26755L20.6302 5.62327L19.4554 4.00466L16.9869 5.79629V4H14.9869V5.76246L12.565 4.00466L11.3902 5.62327L14.9869 8.23371V14.2648L9.88675 11.2818L9.44784 6.7665L7.46712 6.95168L7.76755 10.0423L6.22856 9.14217L5.23827 10.8798L6.74805 11.7628L4.00852 13.0204L4.84057 14.8507L8.86725 13.0023L13.9945 16.0012Z"
      fill="url(#paint0_linear_3029_20574)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3029_20574"
        x1="15.9981"
        y1="4"
        x2="15.9981"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B2D4F7" />
        <stop offset="1" stopColor="#D9E2F3" />
      </linearGradient>
    </defs>
  </svg>
);
